// imports
import { Address } from 'abitype';
import MainNet from '../../web3/abi/mainnet.json';
import Sepolia from '../../web3/abi/sepolia.json';

// interfaces / types / consts
const L1Chain = (process.env.REACT_APP_ENVIRONMENT === 'prod' || process.env.REACT_APP_ENVIRONMENT === 'stage') ? MainNet : Sepolia;
const NETWORK = (process.env.REACT_APP_ENVIRONMENT === 'prod' || process.env.REACT_APP_ENVIRONMENT === 'stage') ? 'eth-mainnet' : 'eth-sepolia';
const API_KEY = process.env.REACT_APP_ALCHEMY_API_KEY || '';
const CONTRACT_ADDRESS = L1Chain.contracts.Immortals.address;
const BASE_URL = `https://${NETWORK}.g.alchemy.com/nft/v2/${API_KEY}/getNFTs?withMetadata=false&contractAddresses[]=${CONTRACT_ADDRESS}&owner=`;

interface Response { ownedNfts: [{ id: { tokenId: Address } }]; totalCount: number; pageKey: string }

// private methods
const getAllNFTs = (url: string, tokenIds?: number[], pageKey?: string): Promise<number[]> => fetch(`${url}&pageKey=${pageKey || ''}`, {
  headers: { 'Content-Type': 'application/json' }
}).then((response) => {
  if (response.status !== 200) { return response.json().then((errMsg) => Promise.reject(errMsg)); }
  return response.json();
}).then((res: Response) => {
  const { ownedNfts, pageKey: currPageKey, totalCount } = res;
  const currPageTokens = ownedNfts.map((info) => Number(info.id.tokenId));
  const accumulatedTokens = (tokenIds || []).concat(currPageTokens);
  if (!currPageKey && accumulatedTokens.length === totalCount) {
    return Promise.resolve(accumulatedTokens);
  }
  return getAllNFTs(url, accumulatedTokens, currPageKey);
});

// exports
export const getNFTs = (owner: Address): Promise<number[]> => getAllNFTs(`${BASE_URL}${owner}`);

export default { getNFTs };
